// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3k5Pk","footer":"Form_footer__2C4V2"};